module.exports = __webpack_public_path__ + "img/20201101_161050.2b4cc137.jpg";